/* eslint-disable max-len */
class AppSettings {
	constructor() {
		let backendHost;
		const apiVersion = 'v1';
		const hostname = window && window.location && window.location.hostname;
		if (hostname === 'imagecompressor.io' || hostname === 'www.imagecompressor.io') {
			backendHost = 'https://api.imagecompressor.io';
		} else if (hostname === 'dev.imagecompressor.io') {
			backendHost = 'https://dev.api.imagecompressor.io';
		} else {
			backendHost = 'http://localhost:5000';
		}
		this.HOST = `${backendHost}/api/${apiVersion}`;
		this.COMPARISON_IMAGE = {
			url: 'https://res.cloudinary.com/imagecompressor/image/upload/v1645298950/imagecompressor.io/pexels_photo_4108334-235PHTgs_xhdfpn.jpg',
			originalFilePath: 'https://res.cloudinary.com/imagecompressor/image/upload/v1645298950/imagecompressor.io/pexels_photo_4108334-235PHTgs_xhdfpn.jpg',
			width: 1048,
			height: 528,
			displayWidth: 1800,
			displayHeight: 1200,
			sizeFormatted: '298.99 KB',
			compressedSizeFormatted: '128.99 KB'
		};
	}
}

const instance = new AppSettings();
Object.freeze(instance);
export default instance;



// WEBPACK FOOTER //
// ./src/AppSettings.js